module.exports = __webpack_public_path__ + "img/play.7dad24a2.svg";